import React, { Component } from 'react';
import WowHeader from 'components/common/WowHeader'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as wowActions from 'store/modules/wow';
// import {bindActionCreators} from 'redux';
// import * as baseActions from 'store/modules/base';

class WowHeaderContainer extends Component {

  componentDidMount() {
    const {WowActions} = this.props;
    const lang = navigator.language.indexOf('ko') > -1 ? 'kr' : 'eng';
    WowActions.setWowfindLang({lang});
  }

  fnLanguage = (lang) => {
    const {WowActions} = this.props;
    WowActions.setWowfindLang({lang});
  }

  render() {
    const {fnLanguage} = this;
    const {lang} = this.props;

    return (
      <WowHeader
      fnLanguage={fnLanguage}
      lang={lang}
      />
    );
  }
}

export default connect(
  (state) => ({
    lang: state.wow.toJS().lang
  }),
  (dispatch) => ({
    WowActions: bindActionCreators(wowActions, dispatch)
  })
)(WowHeaderContainer);